var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRentedUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60039 16.4V6H2.40039V17.6H18.6004V6H17.4004V16.4H3.60039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5903 0.302734L20.3141 6.27086L19.6864 7.29359L10.5685 1.69733C9.16544 2.50958 7.3367 3.6548 5.66126 4.70401C5.51038 4.7985 5.36074 4.89221 5.21276 4.98483C4.25964 5.58139 3.3756 6.13264 2.68209 6.5491C2.33566 6.75714 2.03177 6.93455 1.78793 7.0683C1.56436 7.19093 1.33769 7.3075 1.17231 7.35702L0.828125 6.20744C0.830215 6.20669 0.862189 6.19533 0.936691 6.15937C1.00763 6.12513 1.09893 6.07756 1.21084 6.01618C1.43439 5.89356 1.72278 5.72543 2.06431 5.52034C2.74673 5.11054 3.62137 4.56521 4.5761 3.96764C4.72569 3.87402 4.87724 3.77911 5.03029 3.68326C6.82327 2.5604 8.82251 1.30837 10.2821 0.478095L10.5903 0.302734Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3959 10.2335C10.7895 10.2335 11.1085 9.91447 11.1085 9.52095C11.1085 9.12742 10.7895 8.8084 10.3959 8.8084C10.0024 8.8084 9.6834 9.12742 9.6834 9.52095C9.6834 9.91447 10.0024 10.2335 10.3959 10.2335ZM10.3959 11.4335C11.4522 11.4335 12.3085 10.5772 12.3085 9.52095C12.3085 8.46467 11.4522 7.6084 10.3959 7.6084C9.33967 7.6084 8.4834 8.46467 8.4834 9.52095C8.4834 10.5772 9.33967 11.4335 10.3959 11.4335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13848 13.5105C7.63684 13.8867 7.38262 14.3607 7.38262 14.8337H6.18262C6.18262 13.8983 6.68953 13.0972 7.41848 12.5505C8.14724 12.0039 9.12652 11.6836 10.1827 11.6836C11.2389 11.6836 12.2182 12.0039 12.9469 12.5505C13.6759 13.0972 14.1828 13.8983 14.1828 14.8337H12.9828C12.9828 14.3607 12.7286 13.8867 12.2269 13.5105C11.7251 13.1341 11.0043 12.8836 10.1827 12.8836C9.36106 12.8836 8.6403 13.1341 8.13848 13.5105Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentedUnit);
export default __webpack_public_path__ + "static/media/rented-unit.6a23cf0e.svg";
export { ForwardRef as ReactComponent };